import {
    SET_RELATIONSHIP,
    SET_RELATIONSHIPNAME,
    SET_RELATIONSHIPREMARK,
    GET_ALLOWED_RELATIONSHIPS_REQUEST,
    GET_ALLOWED_RELATIONSHIPS_SUCCESS,
    GET_ALLOWED_RELATIONSHIPS_FAILURE,
    CLEANUP,
} from "./selectRelationshipType";
  
import {
    getRelationshipCode,
} from "api/api";
  
export const cleanup = () => {
    return {
        type: CLEANUP,
    };
};  
  
export const setRelationship = (relationship) => {
    return {
        type: SET_RELATIONSHIP,
        relationship: relationship,
    };
};
  
export const setRelationshipName = (relationshipName) => {
    return {
        type: SET_RELATIONSHIPNAME,
        relationshipName: relationshipName,
    };
};
  
export const setRelationshipRemark = (relationshipRemark) => {
    return {
        type: SET_RELATIONSHIPREMARK,
        relationshipRemark: relationshipRemark,
    };
};
  
const getAllowedRelationshipsRequest = () => {
    return {
        type: GET_ALLOWED_RELATIONSHIPS_REQUEST,
    };
};
  
const getAllowedRelationshipsSuccess = (payload) => {
    return {
        type: GET_ALLOWED_RELATIONSHIPS_SUCCESS,
        payload: payload,
    };
};
  
const getAllowedRelationshipsFailure = (error) => {
    return {
        type: GET_ALLOWED_RELATIONSHIPS_FAILURE,
        payload: error,
    };
};
  
export const getAllowedRelationships = () => {
    return async (dispatch) => {
        dispatch(getAllowedRelationshipsRequest());
        try {
            var response = await getRelationshipCode();
    
            // return data
            dispatch(getAllowedRelationshipsSuccess(response));
        } catch (error) {
            dispatch(getAllowedRelationshipsFailure(error.message));
        }
    };
};
  